import TextInput from './textInput';
import PasswordField from './passwordField';
import SelectInput from './selectInput';
import CheckboxInput from './CheckboxInput';
import RadioInput from './radioInput';
import RadioGroupInput from './radioGroupInput';
import PhoneInput from './PhoneInput';
import DateInput from './dateInput';
import AutocompleteInput from './autocompleteInput';
import TagsInput from './TagsInput';
export function renderInputComponent(
  field,
  formData,
  formikField,
  meta,
  handleChange,
  style
) {
  // console.log(field);

  switch (field.type) {
    case 'text':
      return (
        <TextInput
          {...formikField}
          meta={meta}
          label={field.label}
          value={formData[field.name] || ''}
          onChange={handleChange}
          required={field.required}
          style={style}
          disabled={field.disabled}
          fullWidth={field.fullWidth}
          tooltipText={field.tooltipText}
        />
      );
    case 'email':
      return (
        <TextInput
          {...formikField}
          meta={meta}
          label={field.label}
          value={formData[field.name] || ''}
          onChange={handleChange}
          required={field.required}
          style={style}
          disabled={field.disabled}
          fullWidth={field.fullWidth}
          tooltipText={field.tooltipText}
        />
      );
    case 'password':
      return (
        <PasswordField
          {...formikField}
          meta={meta}
          label={field.label}
          value={formData[field.name] || ''}
          onChange={handleChange}
          required={field.required}
          style={style}
          fullWidth={field.fullWidth}
          tooltipText={field.tooltipText}
        />
      );
    case 'dropdown':
      return (
        <SelectInput
          {...formikField}
          meta={meta}
          label={field.label}
          options={field.options}
          value={formData[field.name] || ''}
          onChange={handleChange}
          disabled={field.disabled}
          fullWidth={field.fullWidth}
        />
      );
    case 'checkbox':
      return (
        <CheckboxInput
          {...formikField}
          meta={meta}
          label={field.label}
          value={formData[field.name] || ''}
          checked={formData[field.name] || false}
          onChange={handleChange}
          required={field.required}
          style={style}
        />
      );
    case 'radio':
      return (
        <RadioInput
          {...formikField}
          meta={meta}
          label={field.label}
          // value={field.value}
          value={formData[field.name] || ''}
          onChange={handleChange}
          required={field.required}
          style={style}
        />
      );
    case 'radioGroup':
      return (
        <RadioGroupInput
          {...formikField}
          meta={meta}
          label={field.label}
          options={field.options}
          value={formData[field.name] || ''}
          onChange={handleChange}
          required={field.required}
          style={style}
        />
      );
    case 'number':
    case 'phoneWithCountry':
      return (
        <PhoneInput
          {...formikField}
          meta={meta}
          label={field.label}
          value={formData[field.name] || ''}
          onChange={handleChange}
          required={field.required}
          style={style}
          fullWidth={field.fullWidth}
        />
      );
    case 'datePicker':
      return (
        <DateInput
          {...formikField}
          meta={meta}
          label={field.label}
          value={formData[field.name] || ''}
          onChange={handleChange}
          required={field.required}
          style={style}
          fullWidth={field.fullWidth}
        />
      );
    case 'autocomplete':
      return (
        <AutocompleteInput
          {...formikField}
          meta={meta}
          label={field.label}
          options={field.options}
          value={formData[field.name] || ''}
          onChange={handleChange}
          required={field.required}
          style={style}
          fullWidth={field.fullWidth}
        />
      );
    case 'tags':
      return (
        <TagsInput
          label={field.label}
          value={field.value || formData[field.name] || []}
          onChange={(name, newValue) => {
            // Call handleChange with the correct format: (name, value)
            handleChange(name, newValue);
          }}
          options={field.options || []}
          onCreateTag={field.onCreateTag}
          required={field.required}
          helperText={field.helperText}
          disabled={field.disabled}
        />
      );
    case 'multiselect':
      return (
        <AutocompleteInput
          {...formikField}
          meta={meta}
          label={field.label}
          options={field.options}
          value={formData[field.name] || []}
          onChange={handleChange}
          required={field.required}
          style={style}
          fullWidth={field.fullWidth}
          multiple
        />
      );
    default:
      return (
        <TextInput
          {...formikField}
          meta={meta}
          label={field.label}
          value={formData[field.name] || ''}
          onChange={handleChange}
          // required={field.required}
          style={style}
          required="default"
          disabled={field.disabled}
          fullWidth={field.fullWidth}
        />
      );
  }
}
